import { CustomerApiQueryResponse, Customer } from '@components/account/types'
import { parse } from '@helpers/shopify'

export function transformCustomer(
  customerData: CustomerApiQueryResponse
): Customer {
  if (!customerData) return customerData

  const data = parse(customerData) as Customer

  return data
}
